<template>
  <v-data-table
    class="border-top table-custom"
    :class="[this.useDefaultHeaders ? 'table-custom' : 'table-custom-custom-headers']"
    v-bind="computedTableProps"
    :headers="headers"
    :items="items"
  >
    <template #header v-if="!useDefaultHeaders">
      <div class="customtable-tableheader">
        <div style="display: table-row" class="border-bottom">
          <div
            v-for="header in headers"
            :key="header.value"
            :style="{
              minWidth: header.minWidth ? header.minWidth : '',
              width: header.width ? header.width : '',
            }"
            class="text-center py-3 text-caption font-weight-medium customtable-tablecell"
          >
            <div class="d-flex justify-center align-center">
              <slot name="customtable-column-name" :header="header">
                <span>{{ header.text || $i18n.t(header.translatePath) }}</span>
                <span v-if="header.optional" class="text-caption font-weight-thin font-italic">
                  {{ $i18n.t('dialog.body.optional') }}
                </span>
              </slot>
              <slot name="customtable-column-append" :header="header" />
            </div>
          </div>
        </div>
        <slot name="customtable-header" />
      </div>
    </template>
    <template #body="data">
      <div style="display: table-row-group">
        <slot name="customtable-rows" :data="data">
          <template v-for="(row, index) in data.items">
            <slot name="customtable-row" :data="{ row, index }">
              <div style="display: table-row" :key="index">
                <div v-for="header in headers" :key="header.value" class="customtable-tablecell">
                  <slot :name="`item-${header.value}`" :data="row">
                    <span>
                      {{ row[header.value] }}
                    </span>
                  </slot>
                </div>
              </div>
            </slot>
          </template>
        </slot>
      </div>
    </template>
    <!-- <template v-else #item="data">
      <slot name="customtable-row" :data="{ row: data.item, index: data.index }">
        <div style="display: table-row" :key="data.index">
          <div v-for="header in headers" :key="header.value" class="customtable-tablecell" v-bind="header">
            <slot :name="`item-${header.value}`" :data="data.item">
              <span>
                {{ data.item[header.value] }}
              </span>
            </slot>
          </div>
        </div>
      </slot>
    </template> -->
  </v-data-table>
</template>

<script>
export default {
  name: 'CustomTable',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    useDefaultHeaders: {
      type: Boolean,
      default: false,
    },
    headers: {
      type: Array,
      default: () => [],
    },
    tableProps: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    computedTableProps() {
      return {
        footerProps: {
          itemsPerPageOptions: [10, 20, 50, 100, 200],
          showFirstLastPage: true,
        },
        height: '100%',
        itemsPerPage: 100,
        hideDefaultHeader: !this.useDefaultHeaders,
        fixedHeader: true,
        ...this.tableProps,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.table-custom-custom-headers {
  min-height: 0;
  display: flex;
  flex-direction: column;
}

::v-deep .v-data-footer__icons-after {
  margin-right: auto;
}

::v-deep .v-data-footer__select .v-select {
  margin-top: 7px;
  margin-bottom: 7px;
}

table {
  border-collapse: separate;
  table-layout: auto;
}
::v-deep .customtable-tablecell {
  display: table-cell;
  vertical-align: middle;
  @include border(bottom, 1px);
}
::v-deep .customtable-tableheader {
  background-color: #fff;
  display: table-header-group;
  position: sticky;
  top: 0;
  z-index: 2;
}
</style>
